var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1410 128L1410 156",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1410.5,
    cy: 123.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1405.99 123.19C1405.99 119.283 1409.29 116.117 1413.36 116.117C1413.94 116.117 1414.51 116.184 1415.06 116.308C1413.74 115.48 1412.19 115 1410.52 115C1405.81 115 1402 118.806 1402 123.5C1402 128.194 1405.81 132 1410.52 132C1412.81 132 1414.89 131.093 1416.43 129.62C1415.49 130.032 1414.45 130.263 1413.36 130.263C1409.29 130.263 1405.99 127.096 1405.99 123.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1419.4 122.6L1419.37 120.146L1417.54 121.719L1415.3 121.056L1416.11 123.337L1414.77 125.381L1417.1 125.218L1418.5 127.144L1419.13 124.763L1421.34 123.909L1419.4 122.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch4);
export default __webpack_public_path__ + "static/media/church_4.89def664acc46dfe5effb499354f7bb8.svg";
export { ForwardRef as ReactComponent };